import {AgGridReact} from "ag-grid-react";
import React, {useEffect, useRef, useState} from "react";
import {CButton, CCard, CCardBody, CCardHeader, CCol, CRow} from "@coreui/react";
import {connect, useSelector} from "react-redux";

import * as posMethod from "../../../api/method/posMethod";
import {selectedActions} from "../../../redux-store/actions/selected";
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController
} from "chart.js";
import {Chart} from "react-chartjs-2";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import {getPeriodWeeklySale} from "../../../api/api";
dayjs.locale('ko')

const Dashboard = (props) => {
    const {user} = useSelector((props) => props.account);

    const [loading, setLoading] = useState(false);
    const [widgetData, setWidgetData] = useState([]);
    const [noticeList, setNoticeList] = useState([]);
    const [weekData, setWeekData] = useState([]);

    const [columnDefs] = useState([
        {field: "seq", headerName: "No", maxWidth: 100},
        {field: "title", headerName: "제목", flex: 1},
        {field: "instUser", headerName: "등록자", maxWidth: 120},
        {field: "instTime", headerName: "등록일시", maxWidth: 120},
    ]);

    const data = {
        labels: [
            dayjs().add(-7, "d").format("MM/DD(ddd)"),
            dayjs().add(-6, "d").format("MM/DD(ddd)"),
            dayjs().add(-5, "d").format("MM/DD(ddd)"),
            dayjs().add(-4, "d").format("MM/DD(ddd)"),
            dayjs().add(-3, "d").format("MM/DD(ddd)"),
            dayjs().add(-2, "d").format("MM/DD(ddd)"),
            dayjs().add(-1, "d").format("MM/DD(ddd)")],
        datasets: [
            {
                type: "bar",
                label: "금주(" + dayjs().add(-7, "d").format("MM/DD") + " ~ " + dayjs().add(-1, "d").format("MM/DD") + ")",
                backgroundColor: "rgb(255, 99, 132)",
                data: [0, 0, 0, 0, 0, 0, 0],
                borderColor: "red",
                borderWidth: 2
            },
            {
                type: "bar",
                label: "전주(" + dayjs().add(-14, "d").format("MM/DD") + " ~ " + dayjs().add(-8, "d").format("MM/DD") + ")",
                backgroundColor: "rgb(75, 192, 192)",
                data: [0, 0, 0, 0, 0, 0, 0]
            }
        ]
    };

    ChartJS.register(
        LinearScale,
        CategoryScale,
        BarElement,
        PointElement,
        LineElement,
        Legend,
        Tooltip,
        LineController,
        BarController
    );

    const chartRef = useRef();
    const chartId = useRef();

    useEffect(() => {
        props.setSelectCmpCd("");
        props.setSelectBrandCd("");
        props.setSelectStoreCd("");

        getBbsBulletin();
    }, []);

    const getBbsBulletin = () => {
        try {
            const params = {
                cmpCd: user.cmpCd,
                brandCd: user.brandCd
            };

            posMethod.getBbsBulletin(params).then((result) => {
                setNoticeList(result);

                getDashboard();
            });
        } catch (e) {
            console.error(e.message);
        }
    };

    const getDashboard = () => {
        const params = {
            cmpCd: user.cmpCd,
            brandCd: user.brandCd,
            fromSaleDt: dayjs().add(-6, "d").format("YYYYMMDD"),
            toSaleDt: dayjs().format("YYYYMMDD")
        }

        setLoading(true);
        getPeriodWeeklySale(params).then((result) => {
            const { responseBody, responseCode, responseMessage } = result.data;
            console.log("result : ", responseBody);

            if (responseCode === "200") {
                // 차트 규격 데이터 생성
                setWeekData(responseBody);
                setLoading(false);
            }
        })
            .catch((e) => {
                console.log(">>> error :: ", e.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <CCard className={"mb-4"}>
                <CCardBody>
                    <CRow>
                        <CCol sm={5}>
                            <h5 id="notice" className="card-title mb-0">공지사항</h5>
                        </CCol>
                    </CRow>
                    <CRow>
                        <div className="ag-theme-alpine" style={{width: "100%", height: "120%", marginTop: 20}}>
                            <AgGridReact
                                headerHeight={40}
                                rowHeight={35}
                                domLayout={"autoHeight"}
                                rowSelection={"single"}
                                rowData={noticeList}
                                columnDefs={columnDefs}>
                            </AgGridReact>
                        </div>
                    </CRow>
                </CCardBody>
            </CCard>
            <CCard className="mb-4">
                <CCardBody>
                    <CRow>
                        <CCol sm={5}>
                            <h5 id="notice" className="card-title mb-0">매출분석</h5>
                        </CCol>
                    </CRow>
                    <Chart data={data} width={100} height={"30"} options={{maintainAspectRatio: true}}/>
                </CCardBody>
            </CCard>
        </>
    );
};

const mapStateToProps = (state) => {
        const {account, store} = state;
        return {
            account, store
        };
    }
;

const mapDispatchToProps = (dispatch) => {
        return {
            setSelectCmpCd: (cmpCd) => {
                dispatch(selectedActions.setSelectCmpCd(cmpCd));
            },
            setSelectBrandCd: (brandCd) => {
                dispatch(selectedActions.setSelectBrandCd(brandCd));
            },
            setSelectStoreCd: (storeCd) => {
                dispatch(selectedActions.setSelectStoreCd(storeCd));
            }
        };
    }
;


export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
